export const ACTION_CLEAR_ERROR = "ACTION_CLEAR_ERROR";

export interface ActionClearError {
  readonly type: typeof ACTION_CLEAR_ERROR;
}

export default (): ActionClearError => ({ type: ACTION_CLEAR_ERROR });
